import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { ArrowLeft, Calendar, Clock } from 'lucide-react';
import { blogPosts } from '../data/blogData';

const BlogDetail = () => {
  const { id } = useParams();
  const post = blogPosts.find(p => p.id === parseInt(id));

  if (!post) return <Navigate to="/blog" />;

  return (
    <div className="min-h-screen bg-[#FEFCF9]">
      {/* Back link */}
      <div className="bg-[#F5EFE6] py-4 border-b border-[#E8DCC8]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/blog" className="flex items-center space-x-2 text-[#7A6B5D] hover:text-[#C4A265] transition-colors">
            <ArrowLeft className="w-5 h-5" />
            <span className="text-sm tracking-wider uppercase">Back to Journal</span>
          </Link>
        </div>
      </div>

      {/* Hero Image */}
      <div className="aspect-[21/9] sm:aspect-[3/1] max-h-[400px] overflow-hidden">
        <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
      </div>

      {/* Article Content */}
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <div className="flex items-center space-x-4 text-xs text-[#A09486] mb-4">
          <span className="text-[#C4A265] font-medium tracking-wider uppercase">{post.category}</span>
          <span className="flex items-center"><Calendar className="w-3 h-3 mr-1" />{post.date}</span>
          <span className="flex items-center"><Clock className="w-3 h-3 mr-1" />{post.readTime}</span>
        </div>

        <h1 className="text-3xl sm:text-4xl font-serif text-[#3E2723] mb-6 leading-tight">{post.title}</h1>
        <div className="w-12 h-px bg-[#C4A265] mb-8"></div>

        <div className="prose prose-lg max-w-none text-[#5C5549] leading-relaxed space-y-6">
          <p>{post.excerpt}</p>
          {post.content ? post.content.map((para, i) => <p key={i}>{para}</p>) : (
            <>
              <p>
                The art of handcrafted home decor is a tradition that spans centuries in India. Each piece carries within it
                the stories of the artisans who created it, the techniques passed down through generations, and the cultural
                heritage of the region it originates from.
              </p>
              <p>
                At Behat House Atelier, we work closely with master craftspeople to ensure that every product maintains the
                highest standards of quality and authenticity. From the selection of raw materials to the final finishing
                touches, each step is carried out with meticulous attention to detail.
              </p>
              <p>
                Whether it's the intricate gold threadwork of Zardozi, the delicate white-on-white patterns of Chikankari,
                or the vibrant floral motifs of Suzani, each craft form has its own unique charm and character. These are
                not merely decorative items — they are pieces of living history.
              </p>
              <p>
                We believe that by choosing handcrafted over mass-produced, you're not only bringing beauty into your home
                but also supporting the livelihoods of skilled artisans and helping to preserve these magnificent art forms
                for future generations.
              </p>
            </>
          )}
        </div>

        {/* Back to Blog CTA */}
        <div className="mt-12 pt-8 border-t border-[#E8DCC8] text-center">
          <Link to="/blog" className="inline-flex items-center space-x-2 text-[#3E2723] tracking-[0.15em] uppercase text-sm font-medium border-b border-[#C4A265] pb-1 hover:text-[#C4A265] transition-colors">
            <ArrowLeft className="w-4 h-4" /><span>Back to Journal</span>
          </Link>
        </div>
      </article>
    </div>
  );
};

export default BlogDetail;
